import React, { Component } from 'react';
export default class About extends Component {
  render() {
    return (
        <section id="about">
        <div className="row">
          <div className="three columns">
            <img className="profile-pic" src="images/profilepic.jpg" alt="" />
          </div>
          <div className="nine columns main-col">
            <h2>About Me</h2>
            <p>
                I'm a freelance Full Stack Engineer and AWS Solutions Architect with 8+ years of experience across fintech and asset management. I build AI-powered applications, design identity and access systems, and architect cloud infrastructure that scales.
            </p>
            <div className="row">
              <div className="columns contact-details">
                <h2>Contact Details</h2>
                <p className="address">
                  <span>jonahmurraydev@gmail.com</span>
                </p>
              </div>
            </div> {/* end row */}
          </div> {/* end .main-col */}
        </div>
      </section>
    );
  }
}